import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3920b796&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920b796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3920b796')) {
      api.createRecord('3920b796', component.options)
    } else {
      api.reload('3920b796', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3920b796&scoped=true", function () {
      api.rerender('3920b796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/level/index.vue"
export default component.exports